<template>
  <div>
    <div class="header" :style="{ 'background-image': `url(${topNavBg})` }">
      <div class="header-content">
        <BrandIcon />
        <el-menu
          :default-active="defaultActiveIndex"
          router
          class="inline-block"
          mode="horizontal"
          :text-color="color.topNavTextColor"
          :active-text-color="
            color.topNavActiveTextColor || color.topNavTextColor
          "
        >
          <el-menu-item index="dashboard" :route="{ path: '/' }">{{
            $t('text.dashboard').toUpperCase()
          }}</el-menu-item>
        </el-menu>
        <b-navbar class="inline-block" :toggleable="windowWidth < 1140">
          <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
          <b-collapse id="nav-collapse" is-nav>
            <div class="right-side-wrapper">
              <FullScreen v-if="windowWidth > 600" />
              <LanguageBar />
              <TimeClock v-if="windowWidth > 600" />
              <!-- <Reminder /> -->
              <b-nav-item-dropdown class="user-dropdown inline-block" right>
                <template v-slot:button-content>
                  <svg-icon iconClass="user" className="user-icon"></svg-icon>
                </template>
                <b-dropdown-item>
                  <img
                    src="../assets/image/user-black.svg"
                    class="w-25 mr-5 vertical-bottom"
                  />
                  <span>{{ $store.getters[`user/displayName`] }}</span>
                </b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item>
                  <b>{{ $t('text.signed_into') }}:</b>
                  <div>
                    <span>{{
                      $store.getters[`user/selecteOrganisationName`]
                    }}</span>
                    <span
                      v-if="organisations.length > 1"
                      class="ml-5 blue-font underline"
                      @click="showOrganisationPopup()"
                      >({{ $t('text.change') }})</span
                    >
                  </div>
                </b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="logout">
                  <b>{{ $t('text.sign_out') }}</b>
                </b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item
                  @click="goTo('/audit-record')"
                  >Audit Record</b-dropdown-item
                >
                <b-dropdown-item
                  @click="redirectTo('https://www.smartzhealth.com/faqs/')"
                  >{{ $t('text.frequently_asked_questions') }}</b-dropdown-item
                >
                <b-dropdown-item
                  @click="
                    redirectTo('https://www.smartzhealth.com/user-manual/')
                  "
                  >{{ $t('text.information_for_use') }}</b-dropdown-item
                >
                <b-dropdown-item
                  @click="redirectTo('https://www.smartzhealth.com/qsg/')"
                  >{{ $t('text.quick_start_guide') }}</b-dropdown-item
                >
                <b-dropdown-item
                  @click="redirectTo('https://smartzhealth.com/downloads/')"
                  >{{ $t('text.data_privacy') }}</b-dropdown-item
                >
                <b-dropdown-item
                  @click="redirectTo('https://smartzhealth.com/downloads/')"
                  >{{ $t('text.eula') }}</b-dropdown-item
                >
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item v-b-modal.about>{{
                  $t('text.about')
                }}</b-dropdown-item>
              </b-nav-item-dropdown>
            </div>
          </b-collapse>
        </b-navbar>
        <div class="clear-both"></div>
      </div>
    </div>

    <b-modal
      id="about"
      ref="about"
      centered
      :hide-header="true"
      :hide-footer="true"
    >
      <div class="white-bg">
        <img
          :src="$store.getters[`customization/logo`]"
          class="mb-10 mt-40 max-w-150"
        />
        <div class="name mb-5">{{ $t('text.dashboard') }}</div>
        <div class="version mb-30">{{ $t('text.version') }} {{ version }}</div>
      </div>
      <div class="grey-bg">
        <div class="inline-block left-side">
          <div class="mb-40">{{ $t('text.copyright') }}.</div>
          <div class="mb-5">{{ $t('text.support').toUpperCase() }}</div>
          <div>customerservice@smartzag.com</div>
        </div>
        <div class="inline-block right-float text-right">
          <img src="../assets/image/c1.svg" class="mr-10" />
          <img src="../assets/image/c2.svg" />
          <div class="close-btn">
            <b-button variant="outline-primary" @click="closeAboutModal()">{{
              $t('text.close')
            }}</b-button>
          </div>
        </div>
      </div>
    </b-modal>

    <OrganisationSelection
      ref="organisationSelection"
      :organisations="organisations"
      @assignPermissionSuccess="handleSwitchOrganisation"
    />
  </div>
</template>

<script>
import LanguageBar from '@/components/LanguageBar.vue'
import TimeClock from '@/components/TimeClock.vue'
import BrandIcon from '@/components/BrandIcon.vue'
// import Reminder from '@/components/Reminder.vue'
import FullScreen from '@/components/FullScreen.vue'
import OrganisationSelection from '@/components/signIn/OrganisationSelection.vue'

export default {
  data() {
    return {
      version: '',
      windowWidth: window.innerWidth,
      logo: require('../assets/image/smartz-logo.svg')
    }
  },
  components: {
    LanguageBar,
    TimeClock,
    BrandIcon,
    // Reminder,
    FullScreen,
    OrganisationSelection
  },
  mounted() {
    let app = require('../../package.json')
    this.version = app.version
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    })
  },
  watch: {
    '$store.state.patient.patients'() {
      if (!this.$store.state.patient.patients.length) this.$router.push('/')
    }
  },
  methods: {
    logout() {
      this.$loading({
        lock: true,
        text: this.$t('text.signing_out') + '...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$store.dispatch('user/logout')
    },
    closeAboutModal() {
      this.$refs['about'].hide()
    },
    redirectTo(link) {
      window.open(link, '_blank')
    },
    toMyAccount() {
      this.$router.push({
        path: '/manage/my-account'
      })
    },
    goTo(url) {
      this.$router.push({
        path: url
      })
    },
    showOrganisationPopup() {
      if (this.organisations.length <= 1) return
      this.$refs.organisationSelection.openDialog()
    },
    handleSwitchOrganisation() {
      window.location.replace('/')
    }
  },
  computed: {
    organisations() {
      return this.$store.getters[`user/userOwnedOrganisations`]
    },
    dashboardPath() {
      return this.$store.state.patient.patients.length
        ? '/dashboard'
        : '/dashboard/landing'
    },
    activeIndex() {
      return this.$route.path
    },
    defaultActiveIndex() {
      let defaultActiveIndex
      let path = this.$route.path
      switch (true) {
        case path.indexOf('/patients') > -1:
          defaultActiveIndex = 'patients'
          break
        case path.indexOf('/manage') > -1:
          defaultActiveIndex = 'manage'
          break
        case path.indexOf('/dashboard') > -1:
          defaultActiveIndex = 'dashboard'
          break
        default:
          defaultActiveIndex = 'home'
      }
      return defaultActiveIndex
    },
    color() {
      return this.$store.state.customization.colorObjForNewDesign
    },
    topNavBg() {
      return this.$store.state.customization.topNavBg
    }
  }
}
</script>
